const aaa = [
	{
		path: "role",
		component: () => import("@/views/control/role.vue"),
		meta:{title:'员工管理'},
	},{
		path: "AllotRole",
		component: () => import("@/views/control/AllotRole.vue"),
		meta:{title:'分配权限'},
	}
]
export default aaa;